module.exports = __webpack_public_path__ + "static/img/letter.841c855.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructions/img/letter.png
// module id = yXZG
// module chunks = 0